export default "__VITE_ASSET__Xru$b4Nx__"